import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useSchedulingSelector } from '../../../../state/SplitTests/selectors/useSchedulingSelector';
import { useCallback } from 'react';

export const useEndTime = ({ splitTestId }: { splitTestId: string }) => {
  const { dispatch } = useCampaignEditorContext();

  const { endTime } = useSchedulingSelector({ splitTestId }) ?? {};
  const onEndTimeChanged = useCallback(
    (endTime: string) => dispatch({ type: 'SET_END_TIME', payload: { id: splitTestId, endTime } }),
    [dispatch, splitTestId],
  );

  return {
    endTime,
    onEndTimeChanged,
  };
};
